import { createAction, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { delIn } from 'utilitify';

import { ILeadResponseModel, NEW_LEAD_ENTITY_NAME } from '@crm-lead/base';

import { ILeadState } from './types';

const STORE_NAME = '@lead';

const initialState: ILeadState = {
  isLeadLoading: false,
};

const leadStore = createSlice({
  name: STORE_NAME,
  initialState,
  reducers: {
    setLead: (
      state,
      { payload: lead }: PayloadAction<ILeadResponseModel | undefined>
    ) => {
      state[lead?.id || NEW_LEAD_ENTITY_NAME] = lead;
    },
    removeLeadFromState: (
      state,
      {
        payload: { leadId },
      }: PayloadAction<{ leadId: ILeadResponseModel['id'] }>
    ) => delIn(state, leadId.toString()),
    setIsLeadLoading: (
      state,
      { payload: isLeadLoading }: PayloadAction<boolean>
    ) => {
      state.isLeadLoading = isLeadLoading;
    },
  },
});

const GET_LEAD_FROM_SERVER = `${STORE_NAME}/getLeadFromServer` as const;

export const leadActions = {
  ...leadStore.actions,
  getLeadFromServer: createAction<number, typeof GET_LEAD_FROM_SERVER>(
    GET_LEAD_FROM_SERVER
  ),
};

export const leadReducer = leadStore.reducer;
